module.exports = __webpack_public_path__ + "8b146470c97755c0ae0e43402e657b87.svg";